"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timedOut = void 0;
var tslib_1 = require("tslib");
var sleep_1 = require("./sleep");
exports.timedOut = function (mainPromise, timeout, onTimeoutFallback) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var maxTimeoutSymbol, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                maxTimeoutSymbol = Symbol('Timeout');
                return [4 /*yield*/, Promise.race([
                        mainPromise,
                        sleep_1.sleep(timeout).then(function () { return maxTimeoutSymbol; }),
                    ])];
            case 1:
                result = _a.sent();
                if (result === maxTimeoutSymbol) {
                    return [2 /*return*/, onTimeoutFallback()];
                }
                return [2 /*return*/, result];
        }
    });
}); };
//# sourceMappingURL=timedOut.js.map